import UserOrders from "../features/User/components/UserOrders";

export default function UserOrdersPage() {
  return <UserOrders />;
}
